import { render, staticRenderFns } from "./LoginContent.vue?vue&type=template&id=64cff491&scoped=true&"
import script from "./LoginContent.vue?vue&type=script&lang=js&"
export * from "./LoginContent.vue?vue&type=script&lang=js&"
import style0 from "./LoginContent.vue?vue&type=style&index=0&id=64cff491&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cff491",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VImg,VRow})
